import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import additionalBuyerCard from 'services/additionalBuyerCard'
import { AdditionalCardRequest } from 'services/additionalBuyerCard/typings'
import { ServerError } from 'typings/serverError'

export interface AdditionalBuyerCardState {
  isLoading: boolean
  isSuccessResponse: boolean
  error: ServerError
}

export const initState: AdditionalBuyerCardState = {
  isLoading: false,
  isSuccessResponse: false,
  error: null
}

export const postAdditionalBuyerCard = createAsyncThunk(
  'additionalBuyerCardSlice/postAdditionalBuyerCard',
  async (payload: AdditionalCardRequest, { rejectWithValue }) => {
    try {
      return await additionalBuyerCard.postAdditionalCard(payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const additionalBuyerCardSlice = createSlice({
  name: 'additionalBuyerCardSlice',
  initialState: initState,
  reducers: {
    resetAdditionalBuyerCardState: (state: AdditionalBuyerCardState) => {
      state.isLoading = false
      state.isSuccessResponse = false
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(
        postAdditionalBuyerCard.pending,
        (state: AdditionalBuyerCardState) => {
          state.isLoading = true
          state.isSuccessResponse = false
          state.error = null
        }
      )
      .addCase(
        postAdditionalBuyerCard.fulfilled,
        (state: AdditionalBuyerCardState) => {
          state.isLoading = false
          state.isSuccessResponse = true
        }
      )
      .addCase(
        postAdditionalBuyerCard.rejected,
        (state: AdditionalBuyerCardState, action: PayloadAction<unknown>) => {
          const errorResponse = action.payload as ServerError

          return {
            ...state,
            isLoading: false,
            error: errorResponse
          }
        }
      )
  }
})

export const { resetAdditionalBuyerCardState } =
  additionalBuyerCardSlice.actions

export default additionalBuyerCardSlice.reducer
